import { FormControl, TextV2 } from '@withjoy/joykit';
import React from 'react';
import { TimeZonePicker } from '@shared/components/TimeZonePicker/TimeZonePicker';
import { getFieldMetadata } from '@shared/components/ScheduleEditor/hooks/getFieldMetadata';
import { FieldMetadata } from '@shared/components/ScheduleEditor/hooks/useScheduleFormState';
import { ScheduleEditorData } from '@shared/components/ScheduleEditor/types';

type FormTimeZonePickerProps = {
  fieldName: keyof ScheduleEditorData;
  state: ScheduleEditorData;
  setValue: (key: keyof ScheduleEditorData, value: string) => void;
  label: string;
  placeholder: string;
  meta: Record<keyof ScheduleEditorData, FieldMetadata>;
};

export const FormTimeZonePicker = (props: FormTimeZonePickerProps) => {
  const { state, setValue, fieldName, meta, label, placeholder } = props;
  const metadata = getFieldMetadata(fieldName, meta);

  return (
    <FormControl
      label={<TextV2 typographyVariant="label3">{label}</TextV2>}
      isInvalid={metadata.error}
    >
      <TimeZonePicker
        zIndex={100}
        value={state.timezone}
        onChange={e => {
          setValue('timezone', e?.value as string);
        }}
        placeholder={placeholder}
      />
    </FormControl>
  );
};
